import React from 'react';

import PublicLayout from 'components/layouts/Public';
import SignUpOrganizationForm from 'components/authForms/SignUpOrganizationForm';

import FormSection from 'ui/FormSection';
import AuthSwitchLink from './AuthSwitchLink';
import FooterLabels from './FooterLabels';

const Signup = () => {
  return (
    <PublicLayout isLogin={true}>
      <FormSection slim>
        <div className="account-form-page">
          <SignUpOrganizationForm />
          <AuthSwitchLink to="/login" />
        </div>
      </FormSection>

      <FooterLabels />
    </PublicLayout>
  );
};

export default Signup;
